import {HostingData} from "./hostingData";
import {HostingBasicInfo} from "./hosting-basic-info";
import {HostingSftp} from "./hosting-sftp";
import {HostingDatabase} from "./hosting-database";
import {HostingPasswordProtection} from "./hosting-password-protection";

export class HostingDataMapper {
  public static map(dataList: any): HostingData {
    const hostingData: HostingData = new HostingData();
    hostingData.hostingDatabase = HostingDataMapper.parseDatabase(dataList[0].data.mysql);
    hostingData.hostingSftp = HostingDataMapper.parseSftp(dataList[0].data.sftp);
    hostingData.hostingBasicInfo = HostingDataMapper.parseBasicInfo(dataList[1].data);
    hostingData.hostingPasswordProtection = HostingDataMapper.parsePasswordProtection(dataList[0].data.htpasswd);

    return hostingData;
  }

  private static parseBasicInfo(hostingBasicInfo: HostingBasicInfo): HostingBasicInfo {
    const basicInfo: HostingBasicInfo = new HostingBasicInfo();
    basicInfo.region = hostingBasicInfo.region ? hostingBasicInfo.region : "";
    basicInfo.location = hostingBasicInfo.location ? hostingBasicInfo.location : "";
    basicInfo.ip = hostingBasicInfo.ip ? hostingBasicInfo.ip : "";

    return basicInfo;
  }

  private static parseSftp(hostingSftp: HostingSftp): HostingSftp {
    const sftp: HostingSftp = new HostingSftp();
    sftp.username = hostingSftp.username ? hostingSftp.username : "";
    sftp.password = hostingSftp.password ? hostingSftp.password : "";
    sftp.port = hostingSftp.port ? hostingSftp.port : "";

    return sftp;
  }

  private static parsePasswordProtection(hostingPasswordProtection: HostingPasswordProtection): HostingPasswordProtection {
    const passwordProtection: HostingPasswordProtection = new HostingPasswordProtection();
    passwordProtection.username = hostingPasswordProtection && hostingPasswordProtection.username ? hostingPasswordProtection.username : "";
    passwordProtection.password = hostingPasswordProtection && hostingPasswordProtection.password ? hostingPasswordProtection.password : "";

    return hostingPasswordProtection;
  }

  private static parseDatabase(hostingDatabase): HostingDatabase {
    const database: HostingDatabase = new HostingDatabase();
    database.username = hostingDatabase.username ? hostingDatabase.username : "";
    database.password = hostingDatabase.password ? hostingDatabase.password : "";
    database.name = hostingDatabase.db_name ? hostingDatabase.db_name : "";
    database.path = hostingDatabase.path ? hostingDatabase.path : "";

    return database;
  }

}
